// SQUARE NUMBERING FROM THE COAST (display only, RULES 16 OCT R5): row 0 = the land row next
// to the ORIGINAL coastline (the bottom land row), counting up inland; columns from 1 on the
// left. Sentences: "row 2, col 3"; the board's small labels: "2,3". Internal keys ("r,c" grid
// indices) stay as they are (saves, API).
export function squareNumbers(key, gridRows) {
  const [r, c] = String(key).split(",").map(Number);
  if (!Number.isFinite(r) || !Number.isFinite(c) || !gridRows) return null;
  return [gridRows - 1 - r, c + 1];
}

export function squareShort(key, gridRows) {
  const n = squareNumbers(key, gridRows);
  return n ? `${n[0]},${n[1]}` : String(key);
}

export function squareText(key, gridRows) {
  const n = squareNumbers(key, gridRows);
  return n ? `row ${n[0]}, col ${n[1]}` : String(key);
}
